import { render, staticRenderFns } from "./InfoPanel.vue?vue&type=template&id=c71d670c&scoped=true&"
import script from "./InfoPanel.vue?vue&type=script&lang=js&"
export * from "./InfoPanel.vue?vue&type=script&lang=js&"
import style0 from "./InfoPanel.vue?vue&type=style&index=0&id=c71d670c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71d670c",
  null
  
)

export default component.exports